/* eslint-disable react/display-name */
import { forwardRef } from "react"

import { Icon, Tappable } from "@trueskin-web/components"
import { checkPolygonIcon } from "@trueskin-web/theme/icons/checkPolygonIcon"

const PlanCard = forwardRef(
  (
    { isSelected, plan, isRecommended, onClick, children, className, ...props },
    ref = null
  ) => {
    const { title, isSubscription } = plan

    const dataTestIdPrefix = title?.toLowerCase()

    return (
      <Tappable
        ref={ref}
        data-testid={`web-portal-plan-selection-${dataTestIdPrefix}-plan-block`}
        data-component-name="Plan"
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          p: isSelected ? "15px" : 4,
          background: "white",
          borderRadius: "8px",
          border: isSelected ? "2px solid" : "1px solid",
          borderColor: isSelected
            ? "primary"
            : isSubscription
            ? "brandNeutralsMediumGrey"
            : ["white", "brandNeutralsMediumGrey"],
        }}
        className={className}
        onClick={onClick}
        {...props}
      >
        {children}

        {isRecommended ? (
          <div
            data-testid="web-portal-plan-selection-plan-block-voucher"
            sx={{
              position: "absolute",
              top: 0,
              right: 4,
              transform: "translateY(-50%)",
              py: 1,
              px: 2,
              display: "inline-flex",
              alignItems: "center",
              fontSize: 0,
              background: "#3244FF",
              color: "white",
              borderRadius: "8px",
            }}
          >
            Patient:innen-Liebling
            <Icon icon={checkPolygonIcon} size="sm" sx={{ ml: 1 }} />
          </div>
        ) : null}
      </Tappable>
    )
  }
)

export default PlanCard
